export const NavbarActionTypes = {
	SET_TOGGLE_SIDEBAR: "SET_TOGGLE_SIDEBAR",
	// SET_TOGGLE_SIDEBAR: "SET_TOGGLE_SIDEBAR",
};
